import { render, staticRenderFns } from "./quizier.vue?vue&type=template&id=8000dfd4&"
import script from "./quizier.vue?vue&type=script&lang=js&"
export * from "./quizier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports